import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetAppraisalRowsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
}>;


export type GetAppraisalRowsQuery = { __typename?: 'query_root', appraisal_vehicles: Array<{ __typename?: 'appraisal_vehicles', vin?: string | null, customer_id?: number | null, appraisal?: { __typename?: 'appraisals', id: number, status: string, favorite: boolean, last_save_time_utc: string, last_fetch_time_utc: string } | null, move?: { __typename?: 'moves', id: number, status?: string | null, pickup_time?: string | null, ready_by?: string | null, reference_num?: string | null, vehicle_year?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_color?: string | null, vehicle_odometer?: string | null, consumer_pickup?: boolean | null, consumer_name?: string | null, consumer_phone?: string | null } | null }> };


export const GetAppraisalRowsDocument = gql`
    query getAppraisalRows($customerId: bigint!, $start: timestamptz!, $end: timestamptz!) {
  appraisal_vehicles(
    where: {customer_id: {_eq: $customerId}, move: {ready_by: {_gte: $start, _lte: $end}}}
  ) {
    vin
    customer_id
    appraisal {
      id
      status
      favorite
      last_save_time_utc
      last_fetch_time_utc
    }
    move {
      id
      status
      pickup_time
      ready_by
      reference_num
      vehicle_year
      vehicle_make
      vehicle_model
      vehicle_color
      vehicle_odometer
      consumer_pickup
      consumer_name
      consumer_phone
    }
  }
}
    `;

/**
 * __useGetAppraisalRowsQuery__
 *
 * To run a query within a React component, call `useGetAppraisalRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppraisalRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppraisalRowsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetAppraisalRowsQuery(baseOptions: Apollo.QueryHookOptions<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables> & ({ variables: GetAppraisalRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables>(GetAppraisalRowsDocument, options);
      }
export function useGetAppraisalRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables>(GetAppraisalRowsDocument, options);
        }
// @ts-ignore
export function useGetAppraisalRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables>;
export function useGetAppraisalRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppraisalRowsQuery | undefined, GetAppraisalRowsQueryVariables>;
export function useGetAppraisalRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables>(GetAppraisalRowsDocument, options);
        }
export type GetAppraisalRowsQueryHookResult = ReturnType<typeof useGetAppraisalRowsQuery>;
export type GetAppraisalRowsLazyQueryHookResult = ReturnType<typeof useGetAppraisalRowsLazyQuery>;
export type GetAppraisalRowsSuspenseQueryHookResult = ReturnType<typeof useGetAppraisalRowsSuspenseQuery>;
export type GetAppraisalRowsQueryResult = Apollo.QueryResult<GetAppraisalRowsQuery, GetAppraisalRowsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appraisals/queries/getAppraisalRows.query.gql}
 */
export async function getAppraisalRows(
  variables: GetAppraisalRowsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetAppraisalRowsQuery['appraisal_vehicles']>
export async function getAppraisalRows(
  variables: GetAppraisalRowsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetAppraisalRowsQuery>
export async function getAppraisalRows(
  variables: GetAppraisalRowsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetAppraisalRowsQuery['appraisal_vehicles'] | GetAppraisalRowsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetAppraisalRowsQuery>(
    GetAppraisalRowsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.appraisal_vehicles
}